import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";

export default function ProtectedRoute({ children }) {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  if (!authState || authState.isPending || !authState.isAuthenticated) return null;
  return children;
}
